import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./components/login/login.component";
import {PreRegistrationComponent} from "./components/pre-registration/pre-registration.component";
import {LogoutComponent} from "./components/logout/logout.component";

const routes: Routes = [
  // {path: '', pathMatch: 'full', redirectTo: 'auth/login'},
  {path: 'login', component: LoginComponent},
  {path: 'logout', component: LogoutComponent},
  {path: 'aq-campaigns/:code/acquire', component: PreRegistrationComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoute {
}
